import { render, staticRenderFns } from "./VRadio.vue?vue&type=template&id=78d79dfa&scoped=true"
import script from "./VRadio.ts?vue&type=script&lang=ts&external"
export * from "./VRadio.ts?vue&type=script&lang=ts&external"
import style0 from "./VRadio.vue?vue&type=style&index=0&id=78d79dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d79dfa",
  null
  
)

export default component.exports